import createReactComponent from '../createReactComponent';
export default createReactComponent('dots-vertical', 'DotsVertical', [["path",{"d":"M12.313 12h-.626m.626-5h-.626m.626 10h-.626","key":"svg-0"}]]);